const items = [
    {
      headline: "Pink Kalanchoe",
      price: "RM23",
      image: "marketCarousel-1.png"
    },
    {
      headline: "Philodendron",
      price: "RM20",
      image: "marketCarousel-2.png"
    },
    {
      headline: "Cactus Rando",
      price: "RM5",
      image: "marketCarousel-3.png"
    }
  ];

  export default items;